import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ExchangeRatesDto, GlitterOfferListDto, GlitterOfferSellDto } from '../../../api';
import { Web3Service } from '../../../web3.service';
import { ExchangeService } from '../../../exchange/exchange.service';
import { GlobalService } from '../../../global.service';
import { defs } from '../../../defs';
import { OfferDto } from '../../../api/offerDto';
import { Toastr } from '../../../shared/toastr';

@Component({
	selector: 'narwhalia-glitter-sell-popup',
	templateUrl: './glitter-sell-popup.component.html',
	styleUrls: ['./glitter-sell-popup.component.scss']
})
export class GlitterSellPopupComponent implements OnInit {
	exchangeRates: ExchangeRatesDto;
	form: FormGroup;
	exchangedStartPrice: number;
	exchangedEndPrice: number;
	@Input() resellData: GlitterOfferSellDto
	@Output() closePopup: EventEmitter<boolean>;
	@Output() activateOffer: EventEmitter<GlitterOfferListDto>;
	digitsInfo = defs.digitsInfo;
	@HostListener('document:click', ['$event'])
	clickedOutside(event) {
		const path = event.path || (event.composedPath && event.composedPath());
		if (!this.elementRef.nativeElement.contains(event.target) && path[0].type !== 'button' && path[0].type !== 'submit') {
			this.closePopup.emit(true);
		}
	}

	constructor(
		private fb: FormBuilder,
		private exchangeService: ExchangeService,
		private globalService: GlobalService,
		private elementRef: ElementRef,
		private web3Service: Web3Service,
		private toastr: Toastr
	) {
		this.form = this.fb.group({
			glitterFormControl: ['', [Validators.required, Validators.min(1)]],
			startPriceFormControl: ['', [Validators.required, Validators.min(0)]],
			endPriceFormControl: ['', [Validators.required, Validators.min(0)]],
			periodFormControl: ['', [Validators.required, Validators.min(1)]]
		});
		this.exchangedStartPrice = 0;
		this.exchangedEndPrice = 0;
		this.closePopup = new EventEmitter<boolean>();
		this.activateOffer = new EventEmitter<GlitterOfferListDto>();
	}

	ngOnInit() {
		this.globalService.exchangeRates.subscribe(rates => {
			this.exchangeRates = rates;
			if (this.resellData) {
				const { amount, startPrice, endPrice, period } = this.resellData;
				this.form.get('glitterFormControl').setValue(amount);
				this.form.get('glitterFormControl').disable();
				this.form.get('startPriceFormControl').setValue(startPrice);
				this.form.get('endPriceFormControl').setValue(endPrice);
				this.form.get('periodFormControl').setValue(period / defs.dayToMinutes);
			}
			this.exchangePrice('start');
			this.exchangePrice('end');
		});
	}

	close = () => {
		this.closePopup.emit();
	};

	exchangePrice(whichPrice: string) {
		if (whichPrice === 'start') {
			this.exchangedStartPrice = this.form.get('startPriceFormControl').value * this.exchangeRates.eth_usd;
		} else if (whichPrice === 'end') {
			this.exchangedEndPrice = this.form.get('endPriceFormControl').value * this.exchangeRates.eth_usd;
		}
	}

	offerGlitterPackage() {
		if (this.resellData) {
			const id = this.resellData.id;
			const sale: OfferDto = {
				startPrice: this.form.get('startPriceFormControl').value,
				endPrice: this.form.get('endPriceFormControl').value,
				period: this.form.get('periodFormControl').value * defs.dayToMinutes
			};
			this.exchangeService.resellOffer(id, sale).subscribe(activatedOffer => {
				this.closePopup.emit(true);
				this.activateOffer.emit(activatedOffer);
			});
		} else {
			this.web3Service.init().then(() => {
				this.exchangeService
					.offerGlitterPackage({
						amount: this.form.get('glitterFormControl').value,
						startPrice: this.form.get('startPriceFormControl').value,
						endPrice: this.form.get('endPriceFormControl').value,
						period: this.form.get('periodFormControl').value * defs.dayToMinutes
					})
					.then(this.web3Service.send)
					.then(() => {
						this.toastr.success('glitter.offered')
						this.close
					})
					.catch(err => {
						console.error(err);
					});
			});
		}
	}
/*
	transferGtr = (response: BuyResponseDto) => {
		return this.web3Service.send(response)
			.then(this.exchangeService.sendTransactionHashGlitterSell)
			.catch(this.handleError);
	};
*/
}